import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/user-16.jpg'
import _imports_1 from '@/assets/images/user-17.jpg'
import _imports_2 from '@/assets/images/user-18.jpg'
import _imports_3 from '@/assets/images/user-19.jpg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "position-relative timeline-item" }
const _hoisted_4 = { class: "border-style-for-timeline" }
const _hoisted_5 = { class: "ps-0 mb-3 list-unstyled d-flex align-items-center" }
const _hoisted_6 = { class: "ms-m-15" }
const _hoisted_7 = { class: "ms-m-15" }
const _hoisted_8 = { class: "ms-m-15" }
const _hoisted_9 = { class: "ms-m-15" }
const _hoisted_10 = { class: "position-relative timeline-item" }
const _hoisted_11 = { class: "border-style-for-timeline dot-3" }
const _hoisted_12 = { class: "ps-0 mb-3 list-unstyled d-flex align-items-center" }
const _hoisted_13 = { class: "ms-m-15" }
const _hoisted_14 = { class: "ms-m-15" }
const _hoisted_15 = { class: "ms-m-15" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "mb-4" }, [
        _createElementVNode("h3", { class: "mb-0" }, "Basic Timeline")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "time-line-date" }, "Just now", -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "fs-14 fw-medium mb-2" }, "Weekly Stand-Up Meetings:", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "fs-13 mb-4" }, " We continued our weekly stand-up meetings where team members provided updates on their current tasks, discussed any roadblocks, and coordinated efforts for the week ahead. ", -1)),
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("img", {
                    src: _imports_3,
                    class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_RouterLink, {
                to: "/users/users-list",
                class: "wh-34 lh-34 rounded-circle bg-primary d-block text-center text-decoration-none text-white fs-12 fw-medium border border-1 border-color-white"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("+10", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("p", null, [
            _createTextVNode("By: "),
            _createElementVNode("span", { class: "text-primary" }, "Olivia Rodriguez")
          ], -1))
        ])
      ]),
      _cache[18] || (_cache[18] = _createStaticVNode("<div class=\"position-relative timeline-item\"><span class=\"time-line-date\">1 day ago</span><div class=\"border-style-for-timeline dot-2\"><h4 class=\"fs-14 fw-medium mb-2\">Project Kickoff Session:</h4><p class=\"fs-13\"> The session included introductions, a review of project goals and objectives, and initial planning discussions. </p><p>By: <span class=\"text-primary\">Isabella Cooper</span></p></div></div>", 1)),
      _createElementVNode("div", _hoisted_10, [
        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "time-line-date" }, "2 days ago", -1)),
        _createElementVNode("div", _hoisted_11, [
          _cache[13] || (_cache[13] = _createElementVNode("h4", { class: "fs-14 fw-medium mb-2" }, "Team Building Workshop:", -1)),
          _cache[14] || (_cache[14] = _createElementVNode("p", { class: "fs-13 mb-4" }, " Last Friday, we conducted a team building workshop focused on improving communication and collaboration among team members. Activities included team challenges, icebreakers, and open discussions. ", -1)),
          _createElementVNode("ul", _hoisted_12, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_13, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_14, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_15, [
              _createVNode(_component_RouterLink, {
                to: "/users/users-list",
                class: "wh-34 lh-34 rounded-circle bg-primary d-block text-center text-decoration-none text-white fs-12 fw-medium border border-1 border-color-white"
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode(" +10 ", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("p", null, [
            _createTextVNode("By: "),
            _createElementVNode("span", { class: "text-primary" }, "Lucas Morgan")
          ], -1))
        ])
      ]),
      _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"position-relative timeline-item\"><span class=\"time-line-date\">3 days ago</span><div class=\"border-style-for-timeline dot-4 pb-0\"><h4 class=\"fs-14 fw-medium mb-2\">Lunch and Learn Session:</h4><p class=\"fs-13\"> We organized a lunch and learn session on March 15th where a guest speaker from the industry discussed emerging trends in our field. It was an insightful session that sparked valuable discussions among team members. </p><p>By: <span class=\"text-primary\">Ethan Parker</span></p></div></div>", 1))
    ])
  ]))
}